module.exports = __webpack_public_path__ + "img/service-refund.94c165a7.png";